define('lq/enum',['underscore'], function (_) {
	'use strict';

	// Usage:
	// constants.Seasons = new Enum("Seasons", ["Spring", "Summer", "Autumn", "Winter"]);
	// if (currentSeason === constants.Seasons.Summer) { print("Yay, it's summer!"); }

	var freeze = function (obj) {
		if (Object.freeze) {
			Object.freeze(obj);
		}
	};

	var EnumItem = function (enumObject, enumName, name, methods) {
	    var self = this;
        self.enum = enumObject;
		self.enumName = enumName;
		self.name = name;
		_.extend(self, methods);
		freeze(self);
	};

	EnumItem.prototype.toString = function () {
		return "EnumItem " + this.enumName + " " + this.name;
	};

	if (Object.create) {
		// avoid inheriting object methods
		EnumItem.prototype = Object.create(null);
	}

	var Enum = function (name, keys, methods) {
		var self = this;

		keys = keys.slice();
		freeze(keys);

		self.keys = function () {
		    return keys;
		};

		_.each(keys, function (key) {
			self[key] = new EnumItem(self, name, key, methods);
		});

		freeze(self);
	};

	Enum.prototype.values = function () {
	    return _.values(this);
	};

	return Enum;
});

